import { API_ENDPOINTS } from "../../config/api.js";
import { makeApiRequest } from "../apiClient.js";
import { appendFrontendApiLog } from "../../utils/frontendApiLogger.js";

export const workspaceService = {
    getUseCaseListForCompany: async (companyID) => {
        try {
            const requestData = { companyID: Number(companyID || 0) };
            appendFrontendApiLog("workspace.getUseCaseListForCompany.request", {
                data: requestData,
            });
            const response = await makeApiRequest({
                endpoint: API_ENDPOINTS.GET_WORKSPACE,
                method: "POST",
                data: requestData,
                accessToken: localStorage.getItem("accessToken"),
            });
            appendFrontendApiLog("workspace.getUseCaseListForCompany.response", {
                data: requestData,
                response: response.data,
            });
            return response.data;
        } catch (error) {
            appendFrontendApiLog("workspace.getUseCaseListForCompany.error", {
                data: { companyID: Number(companyID || 0) },
                error: error?.message || String(error),
            });
            throw error;
        }
    },
    getWorkSpaceList: async (data) => {
        try {
            const requestData = {
                companyID: Number(data?.companyID ?? data?.companyId ?? 0),
            };
            appendFrontendApiLog("workspace.getWorkSpaceList.request", { data: requestData });
            const response = await makeApiRequest({
                endpoint: API_ENDPOINTS.GET_WORKSPACE,
                method: "POST",
                data: requestData,
                accessToken: localStorage.getItem("accessToken"),
            });
            appendFrontendApiLog("workspace.getWorkSpaceList.response", {
                data: requestData,
                response: response.data,
            });
            return response.data;
        } catch (error) {
            appendFrontendApiLog("workspace.getWorkSpaceList.error", {
                data,
                error: error?.message || String(error),
            });
            console.error("Error creating screen:", error);
            throw error;
        }
    },
    getSQLandFileConfigByCompanyID: async (companyID) => {
        try {
            appendFrontendApiLog("workspace.getSQLandFileConfigByCompanyID.request", {
                companyID,
            });
            const response = await makeApiRequest({
                endpoint: API_ENDPOINTS.SQL_AND_FILE_CONFIG,
                method: "POST",
                data: { companyID },
                accessToken: localStorage.getItem("accessToken"),
            });
            appendFrontendApiLog("workspace.getSQLandFileConfigByCompanyID.response", {
                companyID,
                response: response.data,
            });
            return response.data;
        } catch (error) {
            appendFrontendApiLog("workspace.getSQLandFileConfigByCompanyID.error", {
                companyID,
                error: error?.message || String(error),
            });
            console.error("Error fetching SQL and file config:", error);
            throw error;
        }
    },
    getFieldsByTableName: async (data) => {
        try {
            appendFrontendApiLog("workspace.getFieldsByTableName.request", { data });
            const response = await makeApiRequest({
                endpoint: API_ENDPOINTS.GET_FIELDS_BY_TABLE_NAME,
                method: "POST",
                data,
                accessToken: localStorage.getItem("accessToken"),
            });
            appendFrontendApiLog("workspace.getFieldsByTableName.response", {
                data,
                response: response.data,
            });
            return response.data;
        } catch (error) {
            appendFrontendApiLog("workspace.getFieldsByTableName.error", {
                data,
                error: error?.message || String(error),
            });
            console.error("Error fetching fields by table name:", error);
            throw error;
        }
    },
    create: async (data) => {
        try {
            appendFrontendApiLog("workspace.create.request", { data });
            const response = await makeApiRequest({
                endpoint: API_ENDPOINTS.INSERT_WORKSPACE,
                method: "POST",
                data,
                accessToken: localStorage.getItem("accessToken"),
            });
            appendFrontendApiLog("workspace.create.response", {
                data,
                response: response.data,
            });
            return response.data;
        } catch (error) {
            appendFrontendApiLog("workspace.create.error", {
                data,
                error: error?.message || String(error),
            });
            console.error("Error creating workspace:", error);
            throw error;
        }
    },
    update: async (data) => {
        try {
            appendFrontendApiLog("workspace.update.request", { data });
            const response = await makeApiRequest({
                endpoint: API_ENDPOINTS.UPDATE_WORKSPACE,
                method: "POST",
                data,
                accessToken: localStorage.getItem("accessToken"),
            });
            appendFrontendApiLog("workspace.update.response", {
                data,
                response: response.data,
            });
            return response.data;
        } catch (error) {
            appendFrontendApiLog("workspace.update.error", {
                data,
                error: error?.message || String(error),
            });
            console.error("Error updating workspace:", error);
            throw error;
        }
    },
    delete: async (data) => {
        try {            
            appendFrontendApiLog("workspace.delete.request", { data });
            const response = await makeApiRequest({
                endpoint: API_ENDPOINTS.DELETE_WORKSPACE,
                method: "POST",
                data,
                accessToken: localStorage.getItem("accessToken"),
            });
            appendFrontendApiLog("workspace.delete.response", {
                data,
                response: response.data,
            });
            return response.data;
        } catch (error) {
            appendFrontendApiLog("workspace.delete.error", {
                data,
                error: error?.message || String(error),
            });
            console.error("Error deleting workspace:", error);
            throw error;
        }
    },
    getById: async (id) => {
        try {
            appendFrontendApiLog("workspace.getById.request", {
                data: { useCaseID: id },
            });
            const response = await makeApiRequest({
                endpoint: `${API_ENDPOINTS.GET_BY_ID}`,
                method: "POST",
                data: { useCaseID: id },
                accessToken: localStorage.getItem("accessToken"),
            });
            appendFrontendApiLog("workspace.getById.response", {
                data: { useCaseID: id },
                response: response.data,
            });
            return response.data;
        } catch (error) {
            appendFrontendApiLog("workspace.getById.error", {
                data: { useCaseID: id },
                error: error?.message || String(error),
            });
            console.error("Error fetching workspace by ID:", error);
            throw error;
        }
    },
};
